import React, { useEffect, useState } from 'react';
import { REGISTER_URL } from '../lib/authLinks';

const HeroSection = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      {/* Background gradient with animation */}
      <div className="absolute inset-0 bg-black"></div>
      <div className="absolute inset-0 bg-gradient-to-br from-yellow-900/20 via-yellow-800/5 to-transparent"></div>
      <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent"></div>
      
      {/* Premium animated particles */}
      <div className="absolute inset-0 opacity-40">
        {[...Array(80)].map((_, i) => (
          <div
            key={i}
            className="absolute rounded-full animate-float"
            style={{
              width: `${Math.random() * 4 + 1}px`,
              height: `${Math.random() * 4 + 1}px`,
              background: `radial-gradient(circle, rgba(251, 191, 36, ${Math.random() * 0.8 + 0.2}) 0%, transparent 70%)`,
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`,
              animationDuration: `${3 + Math.random() * 4}s`,
              boxShadow: `0 0 ${Math.random() * 20 + 10}px rgba(251, 191, 36, ${Math.random() * 0.5})`,
            }}
          ></div>
        ))}
      </div>

      {/* Radial gradient overlay */}
      <div className="absolute inset-0 bg-radial-gradient opacity-30" style={{
        background: 'radial-gradient(circle at 50% 50%, rgba(234, 179, 8, 0.15) 0%, transparent 70%)'
      }}></div>

      <div className={`relative z-10 max-w-7xl mx-auto px-8 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
        {/* Center Content */}
        <div className="text-center space-y-10">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight animate-fade-in-down tracking-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
            Smarter Trading Starts With{' '}
            <span className="gradient-gold-text">SpreadexAsia</span>
          </h1>
          
          <p className="text-xl md:text-2xl lg:text-3xl text-gray-300 max-w-4xl mx-auto animate-fade-in-up animate-delay-200 leading-relaxed font-light">
            AI-powered automated trading for Forex & Stock Markets — trade 24/7 without manual effort.
          </p>
          <div className="pt-8 animate-fade-in-up animate-delay-400 flex flex-col sm:flex-row items-center justify-center gap-6">
            <a href={REGISTER_URL} target="_blank" rel="noopener noreferrer">
              <button className="gradient-gold hover:shadow-gold-lg text-black font-bold text-xl px-12 py-5 rounded-2xl transition-all duration-300 hover-scale shadow-gold">
                Get Started
              </button>
            </a>
            <a href="/trading">
              <button className="glass hover:glass-gold text-white font-semibold text-xl px-12 py-5 rounded-2xl transition-all duration-300 hover-lift border border-white/20">
                Learn More
              </button>
            </a>
          </div>

          {/* Trust indicators */}
          <div className="pt-16 animate-fade-in-up animate-delay-600">
            <div className="flex flex-wrap items-center justify-center gap-12 text-gray-400">
              <div className="text-center">
                <div className="text-4xl font-bold gradient-gold-text mb-2">7+</div>
                <div className="text-sm uppercase tracking-wider">Years Experience</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold gradient-gold-text mb-2">24/7</div>
                <div className="text-sm uppercase tracking-wider">AI Trading</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold gradient-gold-text mb-2">100K+</div>
                <div className="text-sm uppercase tracking-wider">Active Traders</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
